// GLOBAL CONSTANTS
// -----------------------------------

import { SECTION } from "../../../lib/constants";
import { BookingFilterCriteria } from "../../dashboard/types/types";
import CONSTANTS from "../CRUD/constants";

export const APP_COLORS: {
  [index: string]: string;
} = {
  primary: "#FF6136",
  secondary: "#636fc1",
  success: "#27c24c",
  info: "#23b7e5",
  warning: "#ff902b",
  danger: "#f05050",
  inverse: "#131e26",
  green: "#37bc9b",
  pink: "#f532e5",
  purple: "#7266ba",
  dark: "#3a3f51",
  yellow: "#fad732",
  "gray-darker": "#232735",
  "gray-dark": "#3a3f51",
  "gray-darkish": "#999",
  gray: "#dde6e9",
  "gray-light": "#e4eaec",
  "gray-lighter": "#edf1f2",
  "gray-100": " #edeff2",
};

export const APP_MEDIAQUERY = {
  desktopLG: 1200,
  desktop: 992,
  tablet: 768,
  mobile: 480,
};

export const PAYMENT_TYPES_NAMES = {
  es: {
    CREDIT_CARD_VAULT: "Tarjeta como garantía",
    POS: "TPV",
    TRANSFER: "Transfer",
    WITHOUT_CARD: "Reserva sin tarjeta",
    RESERVATION_REQUEST: "Solicitud de reserva",
    PNP_TOKEN: "Pago Tokenizado PNP",
    SIPAY_TOKENIZED_VAULT: "Pago Tokenizado PNP",
    SIPAY_TOKENIZED_POS: "Pago Tokenizado PNP",
    PAYPAL_EXPRESS_CHECKOUT: "PayPal Express Checkout",
    PAYPAL_EXPRESS_STANDARD: "PayPal Express Standard",
    STRIPE: "Stripe",
    PCI_PROXY: "PCI Proxy",
    ADDON_PAYMENTS: "Addon payment",
    PAY_NO_PAIN_V2: "Pago tokenizado PNP v3",
    PAY_NO_PAIN_PROXY: "Paylands Proxy",
    DEFERRED: "Pago diferido",
    CRIPTAN: "Criptan",
    CHECKOUT_PNP: "Checkout PNP",
    PAYCOMET: "Paycomet",
    PAYCOMET_IVR: "Paycomet IVR",
    ADYEN: "Adyen",
    FREEDOM_PAY: "Freedom Pay",
    NEMURU: "Nemuru",
  },
  en: {
    CREDIT_CARD_VAULT: "Credit Card as a Guarantee",
    POS: "TPV",
    TRANSFER: "Transfer",
    WITHOUT_CARD: "No credit card needed",
    RESERVATION_REQUEST: "Booking request",
    PNP_TOKEN: "Tokenized payment PNP",
    SIPAY_TOKENIZED_VAULT: "Tokenized payment PNP",
    SIPAY_TOKENIZED_POS: "Tokenized payment PNP",
    PAYPAL_EXPRESS_CHECKOUT: "PayPal Express Checkout",
    PAYPAL_EXPRESS_STANDARD: "PayPal Express Standard",
    STRIPE: "Stripe",
    PCI_PROXY: "PCI Proxy",
    ADDON_PAYMENTS: "Addon payment",
    PAY_NO_PAIN_V2: "Tokenized payment PNP v3",
    PAY_NO_PAIN_PROXY: "Paylands Proxy",
    DEFERRED: "Deferred payment",
    CRIPTAN: "Criptan",
    CHECKOUT_PNP: "Checkout PNP",
    PAYCOMET: "Paycomet",
    PAYCOMET_IVR: "Paycomet IVR",
    ADYEN: "Adyen",
    FREEDOM_PAY: "Freedom Pay",
    NEMURU: "Nemuru",
  },
};

export const PAYMENT_TYPES_FILTER: { [index: string]: string } = {
  TCG: "TCG",
  TCG_PCI: "TCG_PCI",
  TPV: "TPV",
  TRS: "TRS",
  NO_CARD: "NO_CARD",
  RESERVATION_REQUEST: "RESERVATION_REQUEST",
  TOK: "TOK",
  PAYPAL: "PAYPAL",
  DEFERRED: "DEFERRED",
  CRIPTAN: "CRIPTAN",
  PAYNOPAIN_V2: "PAYNOPAIN_V2",
  pnp_PayNoPain_v3: "pnp_PayNoPain_v3",
  pnp_TC: "pnp_TC",
  pnp_Bizum: "pnp_Bizum",
  pnp_Sofort: "pnp_Sofort",
  pnp_Ideal: "pnp_Ideal",
  pnp_Crypto: "pnp_Crypto",
  pnp_PIX: "pnp_PIX",
  pnp_ViaCash: "pnp_ViaCash",
  pnp_Klarna: "pnp_Klarna",
  pnp_GiroPay: "pnp_GiroPay",
  pnp_GooglePay: "pnp_GooglePay",
  pnp_ApplePay: "pnp_ApplePay",
  pnp_C2P: "pnp_C2P",
  pnp_MercadoPago: "pnp_MercadoPago",
  pcomet_TC: "pcomet_TC",
  pcomet_Bizum: "pcomet_Bizum",
  pcomet_Ideal: "pcomet_Ideal",
  pcomet_Paypal: "pcomet_Paypal",
  pcomet_Klarna: "pcomet_Klarna",
  pcomet_GiroPay: "pcomet_GiroPay",
  pcomet_GooglePay: "pcomet_GooglePay",
  pcomet_ApplePay: "pcomet_ApplePay",
};

export const PAYMENT_TYPES_FILTER_VALUES: { [index: string]: string } = {
  TCG: "cc_vault",
  TCG_PCI: "pay_no_pain_proxy",
  TPV: "pos",
  TRS: "tr",
  NO_CARD: "without_card",
  RESERVATION_REQUEST: "reservation_request",
  TOK: "token_vault,token_pos",
  PAYPAL: "paypal_ec",
  DEFERRED: "deferred",
  CRIPTAN: "criptan",
  PAYNOPAIN_V2: "pay_no_pain_v2",
  pnp_PayNoPain_v3: "pnp_PayNoPain_v3",
  pnp_TC: "pnp_Card",
  pnp_Bizum: "pnp_Bizum",
  pnp_Sofort: "pnp_Sofort",
  pnp_Ideal: "pnp_Ideal",
  pnp_Crypto: "pnp_Crypto",
  pnp_PIX: "pnp_PIX",
  pnp_ViaCash: "pnp_ViaCash",
  pnp_Klarna: "pnp_Klarna",
  pnp_GiroPay: "pnp_GiroPay",
  pnp_GooglePay: "pnp_GooglePay",
  pnp_ApplePay: "pnp_ApplePay",
  pnp_C2P: "pnp_C2P",
  pnp_MercadoPago: "pnp_MercadoPago",
  pcomet_TC: "pcomet_CreditCard",
  pcomet_Bizum: "pcomet_Bizum",
  pcomet_Paypal: "pcomet_Paypal",
  pcomet_Ideal: "pcomet_Ideal",
  pcomet_Sofort: "pcomet_Sofort",
  pcomet_Klarna: "pcomet_Klarna",
  pcomet_GiroPay: "pcomet_GiroPay",
  pcomet_GooglePay: "pcomet_GooglePay",
  pcomet_ApplePay: "pcomet_ApplePay",
  pcomet_IVR: "paycomet_ivr",
  addon_pay_TC: "addon_pay_CreditCard",
  adyen_TC: "adyen_CreditCard",
  adyen_GooglePay: "adyen_GooglePay",
  adyen_ApplePay: "adyen_ApplePay",
  stripe_CreditCard: "stripe_CreditCard",
  stripe_GooglePay: "stripe_GooglePay",
  stripe_ApplePay: "stripe_ApplePay",
  stripe_Klarna: "stripe_Klarna",
  stripe_Link: "stripe_Link",
  freedompay_CreditCard: "freedompay_CreditCard",
  freedompay_GooglePay: "freedompay_GooglePay",
  nemuru_Sequra: "nemuru_Sequra",
  nemuru_Aplazame: "nemuru_Aplazame",
  nemuru_Floa: "nemuru_Floa",
  nemuru_Pepper: "nemuru_Pepper",
};

export const PAYMENT_TYPES = {
  CREDIT_CARD_VAULT: "CREDIT_CARD_VAULT",
  REDSYS: "REDSYS",
  CECA: "CECA",
  TRANSFER: "TRANSFER",
  WITHOUT_CARD: "WITHOUT_CARD",
  RESERVATION_REQUEST: "RESERVATION_REQUEST",
  PNP_TOKEN: "PNP_TOKEN",
  PAY_NO_PAIN_V2: "PAY_NO_PAIN_V2",
  PAY_NO_PAIN_V3: "PAY_NO_PAIN_V3",
  SIPAY_TOKENIZED_VAULT: "SIPAY_TOKENIZED_VAULT",
  SIPAY_TOKENIZED_POS: "SIPAY_TOKENIZED_POS",
  PAYPAL_EXPRESS_CHECKOUT: "PAYPAL_EXPRESS_CHECKOUT",
  PAYPAL_EXPRESS_STANDARD: "PAYPAL_EXPRESS_STANDARD",
  STRIPE: "STRIPE",
  PCI_PROXY: "PCI_PROXY",
  ADDON_PAYMENTS: "ADDON_PAYMENTS",
  POS: "POS",
  PAY_NO_PAIN_PROXY: "PAY_NO_PAIN_PROXY",
  DEFERRED: "DEFERRED",
  CRIPTAN: "CRIPTAN",
  CHECKOUT_PNP: "CHECKOUT_PNP",
  PAYCOMET: "PAYCOMET",
  PAYCOMET_IVR: "PAYCOMET_IVR",
  ADYEN: "ADYEN",
  TOK: "TOK",
  FREEDOM_PAY: "FREEDOM_PAY",
  NEMURU: "NEMURU",
};
export const PAYMENT_TYPES_VALUES: { [index: string]: string } = {
  tcgarantia: "tcgarantia",
  tpv: "tpv",
  tr: "tr",
  ext_storage: "ext_storage",
  tctoken: "tctoken",
  tpvtoken: "tpvtoken",
  paypal_ec: "paypal_ec",
  paypal_std: "paypal_std",
  mp: "mp",
  stripe: "stripe",
  cc_vaultemg: "cc_vaultemg",
  pci_proxy: "pci_proxy",
  addon_payments: "addon_payments",
  pay_no_pain_v2: "pay_no_pain_v2",
  pay_no_pain_proxy: "pay_no_pain_proxy",
  without_card: "without_card",
  reservation_request: "reservation_request",
  deferred: "deferred",
  tc_garantia_pci: "TC Garantía (PCI)",
  checkout_pnp: "checkout_pnp",
  paycomet: "paycomet",
  adyen: "adyen",
  freedom_pay: "freedom_pay",
  nemuru: "nemuru",
};

export const NON_REFUNDABLE_PAYMENTS = [PAYMENT_TYPES.ADDON_PAYMENTS];

export const CHECKOUT_PNP_PAYMENTS_METHODS_FILTER_LABEL: { [index: string]: string } = {
  CARD: "pnp_Card",
  BIZUM: "pnp_Bizum",
  GOOGLE_PAY: "pnp_GooglePay",
  APPLE_PAY: "pnp_ApplePay",
  SOFORT: "pnp_Sofort",
  IDEAL: "pnp_Ideal",
  PAYMENT_CARD: "pnp_PayNoPain_v2",
  CRYPTO: "pnp_Crypto",
  PIX: "pnp_PIX",
  VIACASH: "pnp_ViaCash",
  KLARNA: "pnp_Klarna",
  GIROPAY: "pnp_GiroPay",
  CLICKTOPAY: "pnp_C2P",
  MERCADO_PAGO: "pnp_MercadoPago",
};

export const PAYCOMET_PAYMENTS_METHODS_FILTER_LABEL: { [index: string]: string } = {
  Tarjeta: "pcomet_CreditCard",
  Bizum: "pcomet_Bizum",
  iDEAL: "pcomet_Ideal",
  Paypal: "pcomet_Paypal",
  "Klarna Paynow": "pcomet_Sofort",
  "Klarna Payments": "pcomet_Klarna",
  Giropay: "pcomet_GiroPay",
  GooglePay: "pcomet_GooglePay",
  ApplePay: "pcomet_ApplePay",
};

export const ADYEN_PAYMENTS_METHODS_FILTER_LABEL: { [index: string]: string } = {
  amex: "adyen_CreditCard",
  visa: "adyen_CreditCard",
  mc: "adyen_CreditCard",
  paywithgoogle: "adyen_GooglePay",
  visa_applepay: "adyen_ApplePay",
  mc_applepay: "adyen_ApplePay",
};

export const STRIPE_PAYMENTS_METHODS_FILTER_LABEL: { [index: string]: string } = {
  card: "stripe_CreditCard",
  google_pay: "stripe_GooglePay",
  apple_pay: "stripe_ApplePay",
  klarna: "stripe_Klarna",
  link: "stripe_Link",
};

export const FREEDOM_PAY_PAYMENTS_METHODS_FILTER_LABEL: { [index: string]: string } = {
  CREDIT_CARDS: "freedompay_CreditCard",
  GOOGLE_PAY: "freedompay_GooglePay",
};

export const NEMURU_PAYMENTS_METHODS_FILTER_LABEL: { [index: string]: string } = {
  sequra: "nemuru_Sequra",
  aplazame: "nemuru_Aplazame",
  pepper: "nemuru_Pepper",
  floa: "nemuru_Floa",
};

export const ADDON_PAYMENTS_METHODS_FILTER_LABEL: { [index: string]: string } = {
  caixapucpuce: "addon_pay_CreditCard",
};

export const PAYMENT_TYPES_LABEL: { [index: string]: string } = {
  tcgarantia: "tcgarantia",
  tpv: "tpv",
  tr: "tr",
  ext_storage: "ext_storage",
  tctoken: "tctoken",
  tpvtoken: "tpvtoken",
  paypal_ec: "paypal_ec",
  paypal_std: "paypal_std",
  mp: "mp",
  stripe: "stripe",
  cc_vaultemg: "cc_vaultemg",
  pci_proxy: "pci_proxy",
  addon_payments: "addon_payments",
  pay_no_pain_v2: "pay_no_pain_v2",
  pay_no_pain_proxy: "TC Garantía (PCI)",
  without_card: "without_card",
  reservation_request: "reservation_request",
  deferred: "deferred",
  checkout_pnp: "checkout_pnp",
  adyen: "adyen",
};

export const LOCALE_ISO_PARSER = {
  es: "spa",
  ca: "cat",
  eu: "baq",
  en: "eng",
  fr: "fre",
  pt: "por",
  it: "ita",
  de: "deu",
  nl: "dut",
  ru: "rus",
  ko: "kor",
};

export const REVERSE_LOCALE_ISO_PARSER: { [key: string]: string } = {
  spa: "es",
  cat: "ca",
  baq: "eu",
  eng: "en",
  fre: "fr",
  por: "pt",
  ita: "it",
  deu: "de",
  dut: "nl",
  rus: "ru",
  kor: "ko",
};

export const RESTRICTION_TYPE = {
  MIN_STAY: "MIN_STAY",
  MAX_STAY: "MAX_STAY",
  MIN_NOTICE: "MIN_NOTICE",
  MAX_NOTICE: "MAX_NOTICE",
  OPEN_TRAVEL: "OPEN_TRAVEL",
  OPEN_TRAVEL_START_DATE: "OPEN_TRAVEL_START_DATE",
  OPEN_TRAVEL_END_DATE: "OPEN_TRAVEL_END_DATE",
  TODAY: "TODAY",
  OPEN_BOOKING: "OPEN_BOOKING",
  CLOSE_TRAVEL: "CLOSE_TRAVEL",
  CLOSE_BOOKING: "CLOSE_BOOKING",
  CODE: "CODE",
  DEVICE_TYPE: "DEVICE_TYPE",
  GEOLOCATION: "GEOLOCATION",
  CHECK_IN_CHECK_OUT: "CHECK_IN_CHECK_OUT",
};

export const RESTRICTION_CONFIGURATION_TYPE = {
  CONSTANT: "CONSTANT",
  NO_LIMIT: "NO_LIMIT",
  OWN: "OWN",
  SHARED: "SHARED",
};

export const RATE_TYPE = {
  CONSTANT: "CONSTANT",
  PERCENTAGE: "PERCENTAGE",
  FORMULA: "FORMULA",
  DISC_FIX_STAY: "DISC_FIX_STAY",
  GIVE_NIGHT: "GIVE_NIGHT",
  HIGHLIGHT_MESSAGE: "HIGHLIGHT_MESSAGE",
};

export const UPDATE_ENTITY_ACTIONS = {
  ADD: "ADD",
  REPLACE: "REPLACE",
  DELETE: "DELETE",
};

export const WINDOW_TYPE = {
  TRAVEL: "TRAVEL",
  BOOKING: "BOOKING",
};

export const DISCOUNT_CRITERIA = {
  CHEAPEST: "CHEAPEST",
  MOST_EXPENSIVE: "MOST_EXPENSIVE",
  LAST: "LAST",
};

export const BOOKABLE_TYPE = {
  EXTRA: "EXTRA",
  INVENTORY: "INVENTORY",
  PROMOTION: "PROMO",
};

export const RESTRICTION_VALUE_TYPE = {
  BOOKING_WINDOW_PERIOD_SET: "BOOKING_WINDOW_PERIOD_SET",
  CODE_SET: "CODE_SET",
  COUNTRY_CODE_SET: "COUNTRY_CODE_SET",
  DOUBLE: "DOUBLE",
  DURATION: "DURATION",
  INTEGER: "INTEGER",
  MONEY: "MONEY",
  NONE: "NONE",
  TICKER: "TICKER",
  TRAVEL_WINDOW_PERIOD_SET: "TRAVEL_WINDOW_PERIOD_SET",
  DEVICE_TYPE_SET: "DEVICE_TYPE_SET",
};

export const WEEK_DAYS = {
  MONDAY: "MONDAY",
  TUESDAY: "TUESDAY",
  WEDNESDAY: "WEDNESDAY",
  THURSDAY: "THURSDAY",
  FRIDAY: "FRIDAY",
  SATURDAY: "SATURDAY",
  SUNDAY: "SUNDAY",
};

export const DEVICE_TYPE = {
  DESKTOP: "DESKTOP",
  MOBILE: "MOBILE",
  TABLET: "TABLET",
};

export const CODE_TYPE = {
  NO_CODE: "NO_CODE",
  UNIVERSAL_CODE: "UNIVERSAL_CODE",
};

export const CONTROLS_POSITION = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
};

export const DISPLAY = {
  VIDEO: "VIDEO",
  HTML: "HTML",
  IMAGE: "IMAGE",
};

export const DISPLAY_FILTER_TYPE = {
  ACCOMMODATION: "ACCOMMODATION",
  PROPERTY: "PROPERTY",
};
export const EXTRA_TYPE = {
  ROOM: "ROOM",
  PERSON: "PERSON",
  UNIT: "UNIT",
};

export const DATE_SELECTION_TYPE = {
  NONE: "NONE",
  SPECIFIC: "SPECIFIC",
  ALL: "ALL",
};

export enum StayDaysFilterType {
  ALL_STAY_DAYS_EXCEPT_CHECKOUT = "ALL_STAY_DAYS_EXCEPT_CHECKOUT",
  ALL_STAY_DAYS_EXCEPT_CHECKIN = "ALL_STAY_DAYS_EXCEPT_CHECKIN",
  ALL_STAY_DAYS_EXCEPT_CHECKIN_AND_CHECKOUT = "ALL_STAY_DAYS_EXCEPT_CHECKIN_AND_CHECKOUT",
  ONLY_CHECKIN = "ONLY_CHECKIN",
  ONLY_CHECKOUT = "ONLY_CHECKOUT",
  ALL_STAY_DAYS = "ALL_STAY_DAYS",
  IGNORE = "IGNORE",
}

export const EXTRA_TYPE_VARIANT = {
  ROOM: "ROOM",
  ROOM_PER_DAY: "ROOM_PER_DAY",
  ROOM_MANDATORY: "ROOM_MANDATORY",
  ROOM_PER_DAY_MANDATORY: "ROOM_PER_DAY_MANDATORY",
  ROOM_SPECIFIC_DATE: "ROOM_SPECIFIC_DATE",
  PERSON: "PERSON",
  PERSON_PER_DAY: "PERSON_PER_DAY",
  PERSON_MANDATORY: "PERSON_MANDATORY",
  PERSON_PER_DAY_MANDATORY: "PERSON_PER_DAY_MANDATORY",
  PERSON_SPECIFIC_DATE: "PERSON_SPECIFIC_DATE",
  UNIT: "UNIT",
  UNIT_PER_DAY: "UNIT_PER_DAY",
  UNIT_SPECIFIC_DATE: "UNIT_SPECIFIC_DATE",
  PERCENTAGE: "PERCENTAGE",
  PERCENTAGE_MANDATORY: "PERCENTAGE_MANDATORY",
  PERCENTAGE_SPECIFIC_DATE: "PERCENTAGE_SPECIFIC_DATE",
  LOCK_TYPE_STAY: "STAY",
  LOCK_TYPE_DAY: "DAY",
};

export const EXTRA_VARIANT = {
  PER_DAY: "PER_DAY",
  MANDATORY: "MANDATORY",
  PER_DAY_MANDATORY: "PER_DAY_MANDATORY",
  SPECIFIC_DATE: "SPECIFIC_DATE",
};

export const TRAVEL_WINDOW_TYPE = {
  CONSTANT: "CONSTANT",
  NO_LIMIT: "NO_LIMIT",
};

export const RATE_TYPE_NEW = {
  CONSTANT: "CONSTANT",
  OWN: "OWN",
  PERCENTAGE: "PERCENTAGE",
};

export const RESTRICTIONS_TYPE = {
  CONSTANT: "CONSTANT",
  NO_LIMIT: "NO_LIMIT",
};

export const AVAILABILITY = {
  OWN: "OWN",
  SHARED: "SHARED",
};

export const BLOCKAGE = {
  OWN: "OWN",
  SHARED: "SHARED",
};

export const GUEST_TYPE = {
  SENIOR: "SENIOR",
  ADULT: "ADULT",
  CHILD: "CHILD",
  TEENAGER: "TEENAGER",
  BABY: "BABY",
};

export const CONTRACT_STATUS = {
  PROG: "prog",
  LIVE: "live",
  CANCELLED: "cancelled",
  DEMO: "demo",
  FRONT_BLOCK: "front_block",
  BACK_BLOCK: "back_block",
  TOTAL_BLOCK: "total_block",
};

export const INVOICE_TYPE = {
  PARTNER: "PARTNER",
  DIRECT: "DIRECT",
};

export const LOCALE_FULL = {
  es: "es-ES",
  en: "en-US",
};

export const LOCALE = {
  es: "es",
  en: "en",
};

export const SHARING_TYPE = {
  SHARED: "SHARED",
  SIMPLE: "SIMPLE",
};

export const GOOGLE_FEED = {
  NON_PUBLISHED_TICKERS: "nonPublishedTickers",
  PUBLISHED_TICKERS: "publishedTickers",
  TICKER_TO_PUBLISH: "tickersToPublish",
};

export const PARTNER_ROLE = {
  DIRECT: "DIRECT",
  PARTNER: "PARTNER",
  PRESCRIPTOR: "PRESCRIPTOR",
};

export const RERSERVATION_STATUS = {
  OK: "OK",
  KO: "KO",
  PEND: "PEND",
  CXL: "CXL",
};

export const PAYMENT_STATUS = {
  NOT_REQUIRED: "NOT_REQUIRED",
  NOT_COMPLETED: "NOT_COMPLETED",
  SUCCESS: "SUCCESS",
  PENDING: "PENDING",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
};

export const BACKOFFICE_PAYMENT_TYPES: { [index: string]: string } = {
  cc_vault: "TCG",
  tcgarantia: "TCG",
  pos: "TPV",
  tpv: "TPV",
  tr: "TRS",
  without_card: "SINTC",
  reservation_request: "SOLICITUD",
  token_vault: "TOK",
  tctoken: "TOK",
  token_pos: "TOK",
  tpvtoken: "TOK",
  paypal_ec: "PAL",
  paypal_std: "PAL",
  deferred: "DIF",
};

export const BLACK_LIST_TC_PARTNER = [
  "witbooking.com",
  "clicktotravel.es",
  "ayoweb.es",
  "360hotelmanagement.es",
  "rkpeople.com",
  "zonarev.com",
  "ceomarketing.co",
  "arcestudi.es",
  "insidechannel.com",
  "hoteldyns.com",
  "hotelsdot.com",
  "bookinglineservices.com",
  "hotel-lo.com",
  "thinkin.es",
  "emexs.es",
  "hoteladvisorconsulting.com",
  "beezhotels.com",
  "rinovo.es",
  "coolhotels.es",
  "sekuenz.com",
  "webrevenue.es",
  "hotelerum.com",
  "ms-ecommercehotels.com",
  "emexs.es",
];

export const WHITE_LIST_TC_PARTNER: { [index: string]: string[] } = {
  "sontomaset.com": ["info@clicktotravel.com"],
  "555apartmentsbcn.com": ["almudena.salas@coolhotels.es"],
  capvermellbeach: ["revenue@beezhotels.com", "jose.navarro@beezhotels.com"],
  "hotelabelux.es": ["direccion@hotelabelux.com"],
  "caladorgardens.com": ["direccion@caladorgardens.com", "gardens@caladorgardens.com"],
  "hotelxauen.com": ["revenue@beezhotels.com", "xauen@hotelxauen.com"],
  "apartamentosconmar.com": ["direccion@maypecanteras.es", "j.lucic@witbooking.com"],
  "altahousehotel.com": [
    "info@altahousehotel.com",
    "cristina@thenetrevenue.com",
    "frank@smartroomscompany.com",
  ],
  a10h_clubdelsol_apt: [
    "soldealcudia@a10hotels.com",
    "j.lucic@witbooking.com",
    "basurin@witbooking.com",
  ],
  a10h_soldealcudia_apt: [
    "soldealcudia@a10hotels.com",
    "j.lucic@witbooking.com",
    "basurin@witbooking.com",
  ],
  a10h_solecito_apt_v6: [
    "soldealcudia@a10hotels.com",
    "j.lucic@witbooking.com",
    "basurin@witbooking.com",
  ],
  "utopiasitges.com": ["j.lucic@witbooking.com", "basurin@witbooking.com"],
  demo_lucic: [
    "j.lucic@witbooking.com",
    "basurin@witbooking.com",
    "r.yewang@witbooking.com",
    "s.elaoufi@witbooking.com",
  ],
  "vistaodin.com": ["ramon.juana@gmail.com"],
  "hotelnizasalou.com": ["hotelnizasalou@hotmail.com"],
  "fornalutxpetithotel.com": ["Celine.fph@yahoo.com"],
  "cangaia.com": ["recepcion@cangaia.com"],
  "hqrooms.com": ["jose.navarro@beezhotels.com", "revenue@beezhotels.com", "reservas@hqrooms.com "],
  "hostaloriola.com": ["reservas@hoteloriola.com"],
  "hotelnuro.com": ["hotelnuro@gmail.com"],
  "bungalowsadonis.com": [
    "info@bungalowsadonis.es",
    "adoniswelcome@gmail.com",
    "reservas@bungalowsadonis.es",
    "bungalowsadonis@hotmail.com",
  ],
  "casaalroura.com": ["casaalroura@gmail.com"],
  "balconalvallesalado.es": ["calonsocelada@gmail.com"],
  "thegardensuites.es": ["alberto@civitatis.com", "imartinez@civitatis.com"],
  "casasruralesdeguayadeque.com": ["administracion@restaurantetagoror.com"],
  demo_carmen: ["s.elaoufi@witbooking.com", "c.alcaniz@witbooking.com"],
  espaisblaus_apt: [
    "caterinacb87@gmail.com",
    "info@espaisblaus.com",
    "martinezjesus70@gmail.com",
    "kamal.espaisblaus@gmail.com",
  ],
  espaisblaus_market: [
    "caterinacb87@gmail.com",
    "info@espaisblaus.com",
    "martinezjesus70@gmail.com",
    "kamal.espaisblaus@gmail.com",
  ],
  miravalle_darro: ["gusraff@gmail.com", "reservas@casamiravalle.com"],
  miravalle_catedral: ["gusraff@gmail.com", "reservas@casamiravalle.com"],
  "hotelsavoga.com": ["reserves@savoga.cat"],
  "hondarribiasuites.com": ["amaiagzab@gmail.com", "m.zabalegui@hotmail.com", "jmgoni89@gmail.com"],
  "hotelperalada.com": [
    "carles.dalmau@golfperalada.com",
    "laura.garcia@golfperalada.com",
    "angela.diaz@golfperalada.com",
  ],
  ap_portacoeli: ["marfina@marfina.com"],
  HOTEL_CRISTINA: [
    "reservas@hotelcristinalaspalmas.com",
    "jose@hotelcristinalaspalmas.com",
    "cobros.callcenter@dreamplacehotels.com",
  ],
  DP_TACANDE: ["cobros.callcenter@dreamplacehotels.com"],
  DP_TIGOTAN: ["cobros.callcenter@dreamplacehotels.com"],
  DP_TAGORO: ["cobros.callcenter@dreamplacehotels.com"],
  "curasol.de": ["reception@curasol.de"],
  "hotelalcudiabeach.com": [
    "info@alcudiabeach.eu",
    "recepcion@alcudiabeach.eu",
    "contabilidad@alcudiabeach.eu",
    "direccion@alcudiabeach.eu",
  ],
  "hotelceltavigo.es": ["hotel.celta.vigo@gmail.com"],
  stay_bailen: ["c.jimenez@witbooking.com"],
  "hostalarriazu.com": ["administracion@avenidahotel.com"],
  "avenidahotel.es": ["administracion@avenidahotel.com"],
  "hostalespozymina.com": ["administracion@avenidahotel.com"],
  apartamentospozoblanco: ["administracion@avenidahotel.com"],
  praktik_bakery: ["r.yewang@witbooking.com"],
  icon_embassy: ["r.yewang@witbooking.com"],
  demo_urbano: ["r.yewang@witbooking.com"],
  marinshotels_playasuites: ["administracion@marinshotels.com"],
  demo_toni: ["r.yewang@witbooking.com"],
};

export const ENTITY_NAME_TO_SECTION = {
  [CONSTANTS.ENTITY.EMAIL_TEMPLATE.name]: SECTION.CUSTOM_EMAIL,
  [CONSTANTS.ENTITY.FILTER.name]: SECTION.FILTERS,
  [CONSTANTS.ENTITY.NESTEDFILTER.name]: SECTION.FILTERS,
  [CONSTANTS.ENTITY.LEGAL_INFO.name]: SECTION.LEGAL_INFO,
  [CONSTANTS.ENTITY.DISPLAY.name]: SECTION.DISPLAY,
  [CONSTANTS.ENTITY.MODIFICATION.name]: SECTION.RESERVATION_MODIFICATION_POLICY,
  [CONSTANTS.ENTITY.PAYMENT_TYPES.name]: SECTION.PAYMENT_METHODS,
  [CONSTANTS.ENTITY.EXTRAS.name]: SECTION.EXTRAS,
  [CONSTANTS.ENTITY.CANCELLATIONPOLICY.name]: SECTION.CANCELLATION_POLICY,
  [CONSTANTS.ENTITY.CANCELLATIONPOLICYCONFIGURATION.name]: SECTION.CANCELLATION_POLICY,
  [CONSTANTS.ENTITY.QUESTIONNAIRE.name]: SECTION.QUESTIONNAIRES,
  [CONSTANTS.ENTITY.NESTEDQUESTIONNAIRE.name]: SECTION.QUESTIONNAIRES,
  [CONSTANTS.ENTITY.CONDITIONS.name]: SECTION.CONDITIONS,
  [CONSTANTS.ENTITY.CONFIGURATION_MANAGER.name]: SECTION.PROPERTY_CONFIGURATION,
  [CONSTANTS.ENTITY.PROMOTIONS.name]: SECTION.PROMOTIONS,
  [CONSTANTS.ENTITY.PROMOTIONSBOOKINGWINDOW.name]: SECTION.PROMOTIONS,
  [CONSTANTS.ENTITY.CLIENTS.name]: SECTION.CRM_CLIENT,
  [CONSTANTS.ENTITY.CONTRACTS.name]: SECTION.CRM_CONTRACT,
  [CONSTANTS.ENTITY.PARTNERS.name]: SECTION.CRM_PARTNER,
  [CONSTANTS.ENTITY.PROPERTIES.name]: SECTION.CRM_PROPERTY,
  [CONSTANTS.ENTITY.SERVICES.name]: SECTION.CRM_SERVICE,
  [CONSTANTS.ENTITY.FORWARDING_RESERVATIONS.name]: SECTION.RESEND_RESERVATION_TO_CHANNEL,
};

export const TIER_TYPE = {
  CONSTANT: "CONSTANT",
  DERIVED: "DERIVED",
};

export const ORGANIZATION_TYPE = {
  AGENCY: "AGENCY",
  COMPANY: "COMPANY",
  NO_ORGANIZATION: "NO_ORGANIZATION",
};

export const LOGO_CONFIGURATION = {
  LARGE: "LARGE",
  LARGE_WHITE: "LARGE_WHITE",
  FAVICON: "FAVICON",
};

export const LINK_TYPES = {
  SUPPORT_CENTER: "SUPPORT_CENTER",
  KNOWLEDGE_DATABASE: "KNOWLEDGE_DATABASE",
};

export const EMAIL_STATUS = {
  SCHEDULED: "SCHEDULED",
  QUEUED: "QUEUED",
  SEND: "SEND",
  INVALID: "INVALID",
  DEFERRAL: "DEFERRAL",
  HARD_BOUNCE: "HARD_BOUNCE",
  SOFT_BOUNCE: "SOFT_BOUNCE",
  SPAM: "SPAM",
  UNSUB: "UNSUB",
  REJECTED: "REJECTED",
  OPEN: "OPEN",
  CLICK: "CLICK",
};

export const LOCAL_STORAGE_KEYS = {
  USER_TICKERS: "userTickers",
  USERNAME: "username",
  INVENTORY_MANAGEMENT_TIME_RANGE_FROM: "INVENTORY_MANAGEMENT_TIME_RANGE_FROM",
  INVENTORY_MANAGEMENT_RECENTLY_USED_DATES: "INVENTORY_MANAGEMENT_RECENTLY_USED_DATES",
  DASHBOARD_FILTER_RESERVATION: BookingFilterCriteria.BY_BOOKING_DATE,
  DASHBOARD_FILTER_DAYS: "DASHBOARD_FILTER_DAYS",
  DASHBOARD_CUSTOM_SEARCH: "DASHBOARD_CUSTOM_SEARCH",
};

export const NO_SHOW_STATUS = {
  NONE: "NONE",
  NO_SHOW: "NO_SHOW",
  SHOWED: "SHOWED",
};

export const CHECKOUT_PNP_PAYMENTS_METHODS_LABEL = {
  BIZUM: "Bizum",
  GOOGLE_PAY: "Google Pay",
  APPLE_PAY: "Apple Pay",
  SOFORT: "Sofort",
  IDEAL: "iDeal",
  PNP_V3: "Pago tokenizado",
  CRYPTO: "Crypto Moneda",
  PIX: "PixPay",
  VIACASH: "VíaCash",
  KLARNA: "Klarna",
  GIROPAY: "GiroPay",
  CLICKTOPAY: "C2P",
  MERCADO_PAGO: "Mercado Pago",
};

export const CHECKOUT_PNP_PAYMENTS_METHODS = {
  BIZUM: "BIZUM",
  GOOGLE_PAY: "GOOGLE_PAY",
  APPLE_PAY: "APPLE_PAY",
  SOFORT: "SOFORT",
  IDEAL: "IDEAL",
  PNP_V3: "PAYMENT_CARD",
  CRYPTO: "CRYPTO",
  PIX: "PIX",
  VIACASH: "VIACASH",
  KLARNA: "KLARNA",
  GIROPAY: "GIROPAY",
  CLICKTOPAY: "CLICKTOPAY",
  MERCADO_PAGO: "MERCADO_PAGO",
};

export const PAYCOMET_PAYMENTS_METHODS_LABEL = {
  CREDIT_CARDS: "Credit cards",
  BIZUM: "Bizum",
  IDEAL: "Ideal",
  PAYPAL: "Paypal",
  KLARNA: "Klarna",
  GIROPAY: "GiroPay",
  SOFORT: "Sofort",
  GOOGLE_PAY: "GooglePay",
  APPLE_PAY: "ApplePay",
};

export const PAYCOMET_PAYMENTS_METHODS = {
  CREDIT_CARDS: "CREDIT_CARDS",
  BIZUM: "BIZUM",
  IDEAL: "IDEAL",
  PAYPAL: "PAYPAL",
  KLARNA: "KLARNA",
  GIROPAY: "GIROPAY",
  SOFORT: "SOFORT",
  GOOGLE_PAY: "GOOGLE_PAY",
  APPLE_PAY: "APPLE_PAY",
};

export const ADDON_PAYMENTS_METHODS_LABEL = {
  CREDIT_CARDS: "Credit cards",
  BIZUM: "Bizum",
  APPLE_PAY: "Apple Pay",
  KLARNA: "Klarna",
  GIROPAY: "GiroPay",
  SOFORT: "Sofort",
  IDEAL: "iDeal",
};

export const ADDON_PAYMENTS_METHODS = {
  CREDIT_CARDS: "creditcards",
  SOFORT: "sofort",
  IDEAL: "ideal",
  GIROPAY: "giropay",
  KLARNA: "klarna",
  BIZUM: "bizum",
  APPLE_PAY: "applepay",
};

export const ADYEN_METHODS_LABEL = {
  CREDIT_CARDS_VISA: "Visa",
  CREDIT_CARDS_AMEX: "American Express",
  CREDIT_CARDS_MASTER_CARD: "Mastercard",
  BIZUM: "Bizum",
  APPLE_PAY: "Apple Pay",
  GOOGLE_PAY: "Google Pay",
};

export const ADYEN_METHODS = {
  CREDIT_CARDS_VISA: "visa",
  CREDIT_CARDS_AMEX: "amex",
  CREDIT_CARDS_MASTER_CARD: "mc",
  BIZUM: "bizum",
  APPLE_PAY: "applepay",
  GOOGLE_PAY: "googlepay",
};

export const DASHBOARD_FILTER_CRITERIA = {
  BY_BOOKING_DATE: "BY_BOOKING_DATE",
  BY_BOOKING_CHECKOUT_DATE: "BY_BOOKING_CHECKOUT_DATE",
  BY_CHECKIN_DATE: "BY_CHECKIN_DATE",
  BY_CHECKOUT_DATE: "BY_CHECKOUT_DATE",
};

export const DASHBOARD_FILTER_CRITERIA_DATE = {
  LAST_N_DAYS: "LAST_N_DAYS",
  CUSTOM_DATE: "CUSTOM_DATE",
};

export const PAYMENT_FORM_ACTIONS = {
  LOAD_AMOUNT: "LOAD_AMOUNT",
  REFUND: "REFUND",
};

export const FREEDOM_PAY_PAYMENTS_METHODS_LABEL = {
  CREDIT_CARDS: "Credit cards",
  GOOGLE_PAY: "GooglePay",
  APPLE_PAY: "ApplePay",
};

export const FREEDOM_PAY_PAYMENTS_METHODS = {
  CREDIT_CARDS: "CREDIT_CARDS",
  GOOGLE_PAY: "GOOGLE_PAY",
  APPLE_PAY: "APPLE_PAY",
};

export const FEATURE_TAGS = {
  waiting_list: "waiting_list",
  combined_rate: "combined_rate",
  bundling_units: "bundling_units",
  dynamic_packages: "dynamic_packages",
  cart_abandonment_session: "CART_ABANDONMENT_SESSION",
  shared_cart: "shared_cart",
  assisted_booking: "assisted_booking",
  quotation: "quotation",
  book_and_join: "book_and_join",
  split_stay: "split_stay",
  // upselling: "upselling",
};
